'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = bindResource;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = exports.getDisplayName = function getDisplayName() {
  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return 'ResourceBound(' + (Component.displayName || Component.name || 'Anonymous') + ')';
};

function bindResource(resources) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var redux = require('redux');
  if (!redux) {
    throw new Error('You must install redux before you can call bindResource.');
  }

  var reactRedux = require('react-redux');
  if (!reactRedux) {
    throw new Error('You must install react-redux before you can call bindResource.');
  }

  var _options$mount = options.mount,
      mount = _options$mount === undefined ? function (props) {
    return props.fetchAll();
  } : _options$mount,
      _options$unmount = options.unmount,
      unmount = _options$unmount === undefined ? function (props) {
    return props.resetAll();
  } : _options$unmount,
      _options$willReceiveP = options.willReceiveProps,
      willReceiveProps = _options$willReceiveP === undefined ? undefined : _options$willReceiveP,
      _options$mapProps = options.mapProps,
      mapProps = _options$mapProps === undefined ? undefined : _options$mapProps,
      _options$mergeProps = options.mergeProps,
      mergeProps = _options$mergeProps === undefined ? undefined : _options$mergeProps,
      _options$connectOptio = options.connectOptions,
      connectOptions = _options$connectOptio === undefined ? undefined : _options$connectOptio;


  return function bindResourceWrapper(WrappedComponent) {
    var ResourceBound = function (_React$Component) {
      _inherits(ResourceBound, _React$Component);

      function ResourceBound() {
        _classCallCheck(this, ResourceBound);

        return _possibleConstructorReturn(this, (ResourceBound.__proto__ || Object.getPrototypeOf(ResourceBound)).apply(this, arguments));
      }

      _createClass(ResourceBound, [{
        key: 'componentDidMount',
        value: function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!mount) {
                      _context.next = 9;
                      break;
                    }

                    _context.prev = 1;
                    _context.next = 4;
                    return mount(this.props);

                  case 4:
                    _context.next = 9;
                    break;

                  case 6:
                    _context.prev = 6;
                    _context.t0 = _context['catch'](1);

                    this.props.onMountError(_context.t0);

                  case 9:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this, [[1, 6]]);
          }));

          function componentDidMount() {
            return _ref.apply(this, arguments);
          }

          return componentDidMount;
        }()
      }, {
        key: 'componentWillReceiveProps',
        value: function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(nextProps) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!willReceiveProps) {
                      _context2.next = 9;
                      break;
                    }

                    _context2.prev = 1;
                    _context2.next = 4;
                    return willReceiveProps(this.props, nextProps);

                  case 4:
                    _context2.next = 9;
                    break;

                  case 6:
                    _context2.prev = 6;
                    _context2.t0 = _context2['catch'](1);

                    this.props.onWillReceivePropsError(_context2.t0);

                  case 9:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, this, [[1, 6]]);
          }));

          function componentWillReceiveProps(_x3) {
            return _ref2.apply(this, arguments);
          }

          return componentWillReceiveProps;
        }()
      }, {
        key: 'componentWillUnmount',
        value: function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!unmount) {
                      _context3.next = 9;
                      break;
                    }

                    _context3.prev = 1;
                    _context3.next = 4;
                    return unmount(this.props);

                  case 4:
                    _context3.next = 9;
                    break;

                  case 6:
                    _context3.prev = 6;
                    _context3.t0 = _context3['catch'](1);

                    this.props.onUnmountError(_context3.t0);

                  case 9:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, this, [[1, 6]]);
          }));

          function componentWillUnmount() {
            return _ref3.apply(this, arguments);
          }

          return componentWillUnmount;
        }()
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, this.props);
        }
      }]);

      return ResourceBound;
    }(_react2.default.Component);

    ResourceBound.propTypes = {
      fetchAll: _propTypes2.default.func.isRequired,
      resetAll: _propTypes2.default.func.isRequired,
      onMountError: _propTypes2.default.func,
      onWillReceivePropsError: _propTypes2.default.func,
      onUnmountError: _propTypes2.default.func
    };

    ResourceBound.defaultProps = {
      onMountError: console.error,
      onWillReceivePropsError: console.error,
      onUnmountError: console.error
    };

    ResourceBound.displayName = getDisplayName(WrappedComponent);

    var keys = Object.keys(resources);
    function mapStateToProps(state) {
      return keys.reduce(function (accum, key) {
        accum[key] = resources[key](state);
        return accum;
      }, {});
    }

    function mapDispatchToProps(dispatch, ownProps) {
      var actions = ['fetch', 'create', 'update', 'destroy', 'reset'];
      var actionName = function actionName(action, _ref4) {
        var _ref5 = _toArray(_ref4),
            first = _ref5[0],
            rest = _ref5.slice(1);

        return '' + action + first.toUpperCase() + rest.join('');
      };

      var actionCreators = redux.bindActionCreators(keys.reduce(function (accum, key) {
        actions.forEach(function (action) {
          accum[actionName(action, key)] = resources[key][action];
        });
        return accum;
      }, {}), dispatch);

      return _extends({}, actionCreators, {
        fetchAll: function fetchAll() {
          return Promise.all(keys.map(function (key) {
            return dispatch(resources[key].fetch());
          }));
        },
        resetAll: function resetAll() {
          return Promise.all(keys.map(function (key) {
            return dispatch(resources[key].reset());
          }));
        }
      });
    }

    return reactRedux.connect(mapProps || mapStateToProps, mapDispatchToProps, mergeProps, connectOptions)(ResourceBound);
  };
}


//////////////////
// WEBPACK FOOTER
// ../dist/bindResource.js
// module id = 897
// module chunks = 0